import { IResult, TFieldSuffix } from '../../../../../../store/admin/roundResults/store';
import { IHoleResult } from '../../../../../../store/admin/holeResults/store';
import { TIFormatPrefix } from '../../../../../../store/admin/roundFormats/store';
import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import { getResultFieldName } from './getResultFieldName';

const isHoleResult = (item: any): item is IHoleResult =>
  (item as IHoleResult).scoreId !== undefined;

type TGetResultField = (
  result: IResult | IHoleResult,
  field: TFieldSuffix,
  prefix: TIFormatPrefix,
  scoreType: ScoreType,
  considerFlight?: boolean,
  formatIsStableFord?: boolean
) => string | number | boolean | undefined;

export const getResultField: TGetResultField = (
  result,
  field,
  prefix,
  scoreType,
  considerFlight,
  formatIsStableFord = false
) => {
  const isHorse = prefix === 'horse';

  const processedPrefix = isHorse
    ? (`${prefix}${considerFlight ? 'Flight' : 'Round'}` as TIFormatPrefix)
    : prefix;

  const resultField = isHoleResult(result)
    ? result[ScoreType[scoreType].toLowerCase() as 'gross' | 'net']
    : result[getResultFieldName(processedPrefix, scoreType, field, false, formatIsStableFord)];

  const formattedResultField =
    field === 'AuxScore'
      ? Number(resultField) === 0
        ? 'E'
        : Number(resultField) > 0
        ? `+${resultField}`
        : resultField
      : resultField;

  return formatIsStableFord ? resultField : formattedResultField;
};
